import { IMiniMachineState } from 'src/machines/shared';
import { useSelector } from '@xstate/react';
import usePolarisActor from 'src/hooks/usePolarisActor';

const expandedDifferentialSelector = (state: IMiniMachineState) => {
  return state.context.completion.expandedDifferential;
};

const useResults = () => {
  const actor = usePolarisActor();

  return useSelector(actor as any, expandedDifferentialSelector);
};

export default useResults;
